"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _theme = _interopRequireDefault(require("./theme"));

var _overrides = _interopRequireDefault(require("./theme/overrides"));

var props = _interopRequireWildcard(require("./theme/props"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var createTheme = function createTheme() {
  var themeOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _themeOptions$palette = themeOptions.palette,
      paletteInput = _themeOptions$palette === void 0 ? {} : _themeOptions$palette,
      other = _objectWithoutProperties(themeOptions, ["palette"]);

  var _paletteInput$error = paletteInput.error,
      error = _paletteInput$error === void 0 ? _theme["default"].palette.error : _paletteInput$error,
      _paletteInput$grey = paletteInput.grey,
      grey = _paletteInput$grey === void 0 ? _theme["default"].palette.grey : _paletteInput$grey,
      _paletteInput$info = paletteInput.info,
      info = _paletteInput$info === void 0 ? _theme["default"].palette.info : _paletteInput$info,
      _paletteInput$primary = paletteInput.primary,
      primary = _paletteInput$primary === void 0 ? _theme["default"].palette.primary : _paletteInput$primary,
      _paletteInput$seconda = paletteInput.secondary,
      secondary = _paletteInput$seconda === void 0 ? _theme["default"].palette.secondary : _paletteInput$seconda,
      _paletteInput$success = paletteInput.success,
      success = _paletteInput$success === void 0 ? _theme["default"].palette.success : _paletteInput$success,
      _paletteInput$warning = paletteInput.warning,
      warning = _paletteInput$warning === void 0 ? _theme["default"].palette.warning : _paletteInput$warning,
      _paletteInput$type = paletteInput.type,
      type = _paletteInput$type === void 0 ? 'light' : _paletteInput$type;
  var light = {
    background: _theme["default"].palette.background,
    divider: _theme["default"].palette.divider,
    text: _theme["default"].palette.text
  };
  var dark = {
    secondary: {
      main: _theme["default"].palette.grey[300]
    },
    background: {
      paper: _theme["default"].palette.grey[900],
      "default": _theme["default"].palette.grey[800]
    }
  };
  var types = {
    dark: dark,
    light: light
  };

  var palette = _objectSpread({
    error: error,
    grey: grey,
    info: info,
    primary: primary,
    secondary: secondary,
    success: success,
    warning: warning,
    type: type
  }, types[type]);

  var innerTheme = (0, _styles.createMuiTheme)({
    palette: palette
  });
  var outerTheme = (0, _deepmerge["default"])(_objectSpread(_objectSpread({}, _theme["default"]), {}, {
    overrides: (0, _overrides["default"])(innerTheme),
    palette: palette,
    props: props
  }), other);
  return (0, _styles.createMuiTheme)(outerTheme);
};

var _default = createTheme;
exports["default"] = _default;